module.exports = __webpack_public_path__ + "static/img/bg.7b308be.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/bg.png
// module id = w8Bd
// module chunks = 1